import { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import { useCadaverService } from 'hooks/useCadaverService'

export const useReconhecimentoCadaver = (props) => {
  const { route } = props
  const cadaverService = useCadaverService()
  const params = useParams()
  const [processando, setProcessando] = useState(false)
  const [cadaver, setCadaver] = useState({})

  useEffect(() => {
    if (params.id) {
      cadaverService.listarCadaver(params.id, setCadaver, setProcessando)
    }
  }, [params.id])

  return {
    cadaver,
    processando,
    params,
  }
}
